<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_4"></a>Copyright © 2010 by Bernard Haisch</p>
<p class="copyrighti">All rights reserved under the Pan-American and International Copyright Conventions. This book may not be reproduced, in whole or in part, in any form or by any means electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system now known or hereafter invented, without written permission from the publisher, The Career Press.</p>
<p class="copyright1"><strong>The Purpose-Guided Universe</strong></p>
<p class="copyright">Edited by Kate Henches</p>
<p class="copyright">Typeset by Gina Hoogerhyde</p>
<p class="copyright">Cover design by Wes Youssi/Tweedfiero</p>
<p class="copyright">Printed in the U.S.A. by Courier</p>
<p class="copyright1">Figures by Marsha Sims (<em><a class="nounder" href="http://www.marshasims.com" target="_blank">www.marshasims.com</a></em>)</p>
<p class="copyright1">To order this title, please call toll-free 1-800-CAREER-1 (NJ and Canada: 201-848-0310) to order using VISA or MasterCard, or for further information on books from Career Press.</p>
<p class="copyright1"><img alt="image" src="images/pub1.jpg"/></p>
<p class="copyright">The Career Press, Inc., 3 Tice Road, PO Box 687,</p>
<p class="copyright">Franklin Lakes, NJ 07417</p>
<p class="copyright"><a class="nounder" href="http://www.careerpress.com" target="_blank">www.careerpress.com</a></p>
<p class="copyright"><a class="nounder" href="http://www.newpagebooks.com" target="_blank">www.newpagebooks.com</a></p>
<p class="copyright1"><strong>Library of Congress Cataloging-in-Publication Data</strong></p>
<p class="copyright2">Haisch, Bernard, 1949-</p>
<p class="copyright2">The purpose-guided universe: believing in Einstein, Darwin, and God / by Bernard Haisch.</p>
<p class="copyright2">      p. cm.</p>
<p class="copyright2">Includes bibliographical references and index.</p>
<p class="copyright2">ISBN 978-1-60163-122-0 — ISBN 978-1-60163-733-8 (ebook)</p>
<p class="copyright2">1. Religion and science. 2. God. 3. Teleology. I. Title.</p>
<p class="copyright3">BL240.3.H355 2010<br/>215—dc22</p>
<p class="copyright4">2010008938</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?1260af17